import { render, staticRenderFns } from "./TabLink.vue?vue&type=template&id=3011bcfd&scoped=true&"
import script from "./TabLink.vue?vue&type=script&lang=js&"
export * from "./TabLink.vue?vue&type=script&lang=js&"
import style0 from "./TabLink.vue?vue&type=style&index=0&id=3011bcfd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3011bcfd",
  null
  
)

export default component.exports